import { Component, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { CreateComponent } from '@app/common/templates/create/create.component';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
	templateUrl: '../../../../common/templates/create/create.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/create/style.scss'],
	providers: [DialogService, MessageService, ConfirmationService]
})
export class TblFirmaCreateComponent extends CreateComponent {
	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		@Optional() public config: DynamicDialogConfig,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public dialogService: DialogService,
		public globals: Globals,
		public messageService: MessageService,
		@Optional() public ref: DynamicDialogRef,
		public router: Router,
		public translate: TranslateService,
	) {
		super(accountService, breadcrumbService, config, confirmationService, crudService, dialogService, globals, messageService, ref, router, translate);

		this.apiUrl = 'TblFirma';
		this.name = 'MENU.FIRMA';
		this.url = '/' + PATH.FIRMA;
		this.fieldgroups.push(
			[
				{ type: 'text', key: 'ankey', required: false, width: 400 },
				{ type: 'text', key: 'bezeichnung', required: true, width: 400 },
				{ type: 'text', key: 'bezeichnung_kurz', required: false, width: 400, maxLength: 32 },
				{ type: 'text', key: 'ansprechpartner', required: false, width: 400 },
				{ type: 'text', key: 'url', required: false, width: 400 },
				{ type: 'text', key: 'email', required: false, width: 400 },
				{ type: 'text', key: 'fax', required: false, width: 400 },
				{ type: 'text', key: 'telefon1', required: false, width: 400 },
				{ type: 'text', key: 'land', required: false, width: 400 },
				{ type: 'plz', key: 'plz', required: false, width: 400 },
				{ type: 'village', key: 'ort', required: false, width: 400, plz_field: 'plz' },
				{ type: 'text', key: 'hausnummer', required: false, width: 400 },
				{ type: 'text', key: 'strasse', required: false, width: 400 },
			]
		);
		this.breadcrumbService.setItems([
			{ label: 'MENU.BHV' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.CREATE', routerLink: [this.url + '/' + PATH.CREATE] }
		]);
	}
}
